import {
  GetTimeSetsQueryParamsType,
  GetTimeSetsQueryResponseType,
} from '@/common/queries/getTimeSets/getTimeSetsQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const getTimeSetsFunction = (
  params: GetTimeSetsQueryParamsType,
): Promise<GetTimeSetsQueryResponseType[]> => {
  return fetchApi.get(`/actions/${params?.fileId}/time_set/damaged_list/`);
};
